import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../helpers/request'
import { notification } from 'antd'
import i from '../../../translations/i'

export type SeoFileType = 'robots' | 'sitemap' | 'llms'

interface SeoFileState {
    content: string
    storage_path: string | null
    generated_at: string | null
}

class SeoFilesController {
    constructor() {
        makeAutoObservable(this)
    }

    render = false

    files: Record<SeoFileType, SeoFileState> = {
        robots: { content: '', storage_path: null, generated_at: null },
        sitemap: { content: '', storage_path: null, generated_at: null },
        llms: { content: '', storage_path: null, generated_at: null },
    }

    get() {
        openApi('get', 'seo_files')
            .then(result => {
                result.data.forEach((file: any) => {
                    this.files[file.type as SeoFileType] = {
                        content: file.content ?? '',
                        storage_path: file.storage_path,
                        generated_at: file.generated_at,
                    }
                })
                this.render = true
            })
    }

    set(type: SeoFileType, content: string) {
        this.files[type].content = content
    }

    save(type: SeoFileType) {
        openApi('post', `seo_files/${type}`, { content: this.files[type].content })
            .then(result => {
                this.files[type] = {
                    content: result.data.content ?? '',
                    storage_path: result.data.storage_path,
                    generated_at: result.data.generated_at,
                }

                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit')
                })
            })
            .catch(err => console.log(err.response))
    }
}

export default new SeoFilesController()
